import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import EmptyState from '../../EmptyState';
import { Admins, Props as WidgetProps } from './Admins';
import WidgetBox, {
  Props as WidgetBoxProps,
} from '../../UserWidgets/_partials/WidgetBox';

import s from './Admins.scss';

const AdminsBox: React.FC<WidgetProps & WidgetBoxProps> = ({
  isEmpty,
  isOwner,
  widgetRemove,
  widgetMoveUp,
  widgetMoveDown,
  widgetMenuRenderer,
  section,
  zone,
  ...props
}) => {
  const { t } = useTranslation();
  const navigateToDyW = () => {
    window.location.replace(Url.browseDeviantsYouWatchLink());
  };
  return (
    <WidgetBox
      section={section}
      zone={zone}
      header={t(`widgets.group_admins.header`)}
      moduleId={props.moduleId}
      widgetMoveUp={widgetMoveUp}
      widgetMoveDown={widgetMoveDown}
      widgetRemove={widgetRemove}
      isEmpty={isEmpty}
      emptyView={
        isOwner ? (
          <EmptyState
            view="small"
            className={s['empty-state']}
            title={t(`widgets.group_admins.empty.title.owner`)}
            subtitle={t(`widgets.group_admins.empty.subtitle.owner`)}
            buttonLabel={t(`widgets.group_admins.empty.CTALabel.owner`)}
            withButton={true}
            onButtonClick={navigateToDyW}
          />
        ) : null
      }
    >
      <Admins isOwner={isOwner} {...props} />
    </WidgetBox>
  );
};
AdminsBox.displayName = 'AdminsBox';

export default AdminsBox;
